module.exports = __webpack_public_path__ + "img/register_mb_03.93af229a.png";